import { firestore } from "@/firebase";
import firebase from "@/firebase.js";
//import firebase from "firebase/app";
//import "firebase/auth";

const state = {
  user: null
};

const getters = {
  user: state => state.user
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  }
};

const ALLOWED_DOMAINS = ["biowatch.me", "biowatch.dk", "bio.watch"];

const isAllowedUser = user => {
  const userEmailDomain = user.email.split("@")[1];
  return ALLOWED_DOMAINS.indexOf(userEmailDomain) >= 0;
};

const actions = {
  async createUser({ commit, dispatch }, user) {
    if (!isAllowedUser(user)) {
      dispatch("addToast", {
        message: "Ineligible domain. Use an approved domain for signup",
        type: "bad"
      });
      dispatch("logout");
      return;
    }
    const userDoc = {
      name: user.displayName,
      type: "tester",
      email: user.email,
      created: Date.now(),
      updated: Date.now()
    };
    await firestore
      .collection("users")
      .doc(user.uid)
      .set(userDoc);
    commit("SET_USER", { uid: user.uid, ...userDoc });
  },
  async userLogin({ commit, dispatch }, user) {
    if (!isAllowedUser(user)) {
      dispatch("addToast", {
        message: "Ineligible domain. Use an approved domain for signin",
        type: "bad"
      });
      dispatch("logout");
      return;
    }

    await firestore
      .collection("users")
      .doc(user.uid)
      .get()
      .then(async doc => {
        if (!doc.exists) await dispatch("createUser", user);
        commit("SET_USER", { uid: doc.id, ...doc.data() });
      })
      .catch(async err => {
        // console.log("Could not get user", err);
      });
  },
  userLogout({ commit }) {
    commit("SET_USER", null);
  },
  login(context) {
    firebase.login();
  },
  logout(context) {
    firebase.logout();
  }
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
};
